// extracted by mini-css-extract-plugin
export default {"header":"HeaderItem_header__Xb1h+","user":"HeaderItem_user__HcAyg","label":"HeaderItem_label__FRZlx"};